import {AnyAction} from "redux";
import {HIDE_POPUP, SET_POPUP} from "./action";
import {POPUPS} from "../reducers/popup";


/**
 * hide the active popup
 * @return {{type: any, payload: {popup: string}}}
 */
export function hidePopup() : AnyAction
{
    return {type: HIDE_POPUP, payload: {}};
}


/**
 * show the add-power-source popup
 * @param x
 * @param y
 * @return {{type: string, payload: {popup_id: string, x: number, y: number}}}
 */
export function showAddPowerSourcePopup(x: number, y: number) : AnyAction
{
    return {type: SET_POPUP, payload: { popup_id: POPUPS.ADD_POWER_SOURCE, x, y}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/popups.ts